import React, { useEffect, useState } from 'react'
import { Heading } from '../../components/Heading'
import { Text } from '../../components/Text'
import FooterSection from '../Footer'
import ConnectUs from '../../components/ConnectUs'
import Header from '../Header'
import { useParams } from 'react-router-dom'

const termsAndConditions = [
  {
    section: '1. Ерөнхий заалт',
    content: [
      {
        title:
          "1.1. Энэхүү веб хуудсыг (цаашид 'Веб сайт' гэх) ашиглах замаар хэрэглэгч (цаашид 'Хэрэглэгч' гэх) нь үйлчилгээний нөхцөлийг зөвшөөрч байна."
      },
      {
        title:
          "1.2. Веб хуудсыг ажиллуулж буй байгууллага болох 'Реженератив Селл Сэнтр ХХК' (цаашид 'Эмнэлэг' гэх) нь үйлчилгээний нөхцөлийг өөрчлөх эрхтэй бөгөөд өөрчлөлт оруулсан нөхцөл нь Веб хуудас дээр нийтлэгдсэнээс хойш хүчин төгөлдөр болно."
      }
    ]
  },
  {
    section: '2. Үйлчилгээний зорилго',
    content: [
      {
        title:
          '2.1. Эмнэлэг нь дараах үйлчилгээний талаар мэдээлэл, зөвлөгөө, захиалгын боломжийг хэрэглэгчдэд хүргэнэ:',
        items: [
          '	•  Хүйн цус, хүйн эдийн үүдэл эс хадгалалт.',
          '	•  SprayCell- Түлэгдэлтийн эмчилгээний хувьсгал',
          '	•  SkinCell - Арьсны гоо сайхны эмчилгээ',
          '	•  HairCell - Үс ургуулах эсийн технологи',
          '	•  ERP экзосомоор баялаг плазм.',
          '	•  Хорт хавдрын эрсдэл тодорхойлох генетик шинжилгээ.',
          '	•  Төрөхөөс өмнөх ургийн генетик шинжилгээ',
          '	•  Төрсний дараах нярайн генетик шинжилгээ',
          '	•  Үр хөврөлийн генетик шинжилгээ'
        ]
      },
      {
        title:
          '2.2. Веб сайт нь зөвхөн мэдээлэл өгөх, эмнэлгийн цаг захиалах зориулалттай бөгөөд эмнэлгийн оношилгоо, эмчилгээний шийдвэрийг орлож чадахгүй.'
      }
    ]
  },
  {
    section: '3. Хэрэглэгчийн үүрэг',
    content: [
      {
        title: '3.1. Хэрэглэгч нь:',
        items: [
          '	•  Үйлчилгээний нөхцөлийг мөрдөх.',
          '	•  Өөрийн хувийн мэдээллийг үнэн зөв оруулах.',
          '	•  Веб сайтыг хууль бус зорилгоор ашиглахгүй байх.'
        ]
      },
      {
        title:
          '3.2. Хэрэглэгч өөрийн нэвтрэх мэдээллийн нууцлалыг хамгаалах үүрэгтэй бөгөөд гуравдагч этгээдэд алдагдсан тохиолдолд үүсэх эрсдэлд өөрөө хариуцлага хүлээнэ.'
      }
    ]
  },
  {
    section: '4. Эмнэлгийн үүрэг',
    content: [
      {
        title:
          '4.1. Эмнэлэг нь хэрэглэгчийн оруулсан хувийн мэдээллийг Монгол Улсын холбогдох хуулийн дагуу хамгаална.'
      },
      {
        title:
          '4.2. Эмнэлэг нь веб сайт дээрх мэдээллийн үнэн зөв байдлыг хангахыг хичээх боловч, аливаа алдаа эсвэл мэдээллийн хоцрогдолд хариуцлага хүлээхгүй.'
      }
    ]
  },
  {
    section: '5. Нууцлалын бодлого',
    content: [
      {
        title:
          '5.1. Эмнэлэг нь хэрэглэгчийн хувийн мэдээллийг гуравдагч этгээдэд шилжүүлэхгүй бөгөөд зөвхөн хэрэглэгчийн зөвшөөрөлтэйгөөр ашиглана.'
      },
      {
        title:
          '5.2. Нууцлалын бодлого нь веб сайт дээр тусдаа заасан бөгөөд үүнийг тусад нь танилцах боломжтой.'
      }
    ]
  },
  {
    section: '6. Хариуцлагын хязгаарлалт',
    content: [
      {
        title:
          '6.1. Веб сайт дахь аливаа алдаатай эсвэл бүрэн бус мэдээллээс үүдсэн хохиролд Эмнэлэг хариуцлага хүлээхгүй.'
      },
      {
        title:
          '6.2. Хэрэглэгч Веб сайтад оруулсан үйлдлийнхээ бүх хариуцлагыг өөрөө хүлээнэ.'
      }
    ]
  },
  {
    section: '7. Оюуны өмч',
    content: [
      {
        title:
          '7.1. Веб сайт дээрх бүх текст, зураг, график болон бусад материал нь Эмнэлгийн өмч бөгөөд зөвшөөрөлгүй ашиглахыг хориглоно.'
      },
      {
        title:
          '7.2. Веб сайтаас хуулбарлах, тараах, өөрчлөх эрхийг зөвхөн Эмнэлэг олгоно.'
      }
    ]
  },
  {
    section: '8. Хэрэглэгчийн үйлчилгээний хүрээ',
    content: [
      {
        title:
          "8.1. Хэрэв хэрэглэгч үйлчилгээтэй холбоотой асуулт, санал гомдолтой бол Веб сайт дээрх 'Холбоо барих' хэсгээр дамжуулан Эмнэлэгтэй холбогдоно."
      },
      {
        title:
          '8.2. Эмнэлэг хэрэглэгчийн гомдлыг хүлээн авч, зохих шийдвэрийг 3-5 ажлын өдрийн дотор өгнө.'
      }
    ]
  },
  {
    section: '9. Хууль эрх зүйн орчин',
    content: [
      {
        title:
          '9.1. Энэхүү үйлчилгээний нөхцөл нь Монгол Улсын холбогдох хууль тогтоомжийн дагуу зохицуулагдана.'
      },
      { title: '9.2. Маргаан гарсан тохиолдолд шүүхээр шийдвэрлэнэ.' }
    ]
  },
  {
    section: '10. Нөхцөл хүлээн зөвшөөрөх',
    content: [
      {
        title:
          '10.1. Хэрэглэгч энэхүү үйлчилгээний нөхцөлийг зөвшөөрснөөр Веб сайтыг ашиглах эрхтэй болно.'
      }
    ]
  }
]
const privacyPolicy = [
  {
    title: '1. Хувийн мэдээлэл цуглуулах',
    content: [
      {
        section: '1.1',
        description:
          '. Бид хэрэглэгчийн дараах төрлийн мэдээллийг цуглуулж болно:',
        details: [
          '	•  Овог, нэр',
          '	•  Холбоо барих мэдээлэл (утасны дугаар, и-мейл хаяг)',
          '	•  Эрүүл мэндийн ерөнхий мэдээлэл (хэрэв шаардлагатай бол)',
          '	•  Төлбөрийн мэдээлэл (онлайн захиалгын үед)',
          '	•  Веб хуудсыг ашиглах явцад үүссэн техникийн мэдээлэл (IP хаяг, хөтчийн төрөл, ашигласан төхөөрөмж)'
        ]
      },
      {
        section: '1.2',
        description: '. Мэдээлэл цуглуулах зорилго:',
        details: [
          '•  Үйлчилгээний чанарыг сайжруулах.',
          '•  Таны захиалгыг боловсруулж, хариу өгөх.',
          '•  Хэрэглэгчдэд мэдээлэл хүргэх.',
          '•  Маркетинг болон сурталчилгааны зорилгоор (хэрэглэгч зөвшөөрсөн тохиолдолд).'
        ]
      }
    ]
  },
  {
    title: 'Хувийн мэдээлэл ашиглах',
    content: [
      {
        section: '2.1',
        description:
          '. Хэрэглэгчийн хувийн мэдээллийг дараах тохиолдолд ашиглана:',
        details: [
          '•  Үйлчилгээний захиалгыг баталгаажуулах болон хариу өгөх.',
          '•  Танилцуулга, шинэ үйлчилгээний мэдээлэл илгээх (хэрэглэгч зөвшөөрсөн тохиолдолд).',
          '•  Хэрэглэгчтэй холбоо барих.'
        ]
      },
      {
        section: '2.2',
        description:
          '. Бид таны хувийн мэдээллийг гуравдагч этгээдэд дараах тохиолдолд өгөх эрхтэй:',
        details: [
          '•  Монгол Улсын хуулийн дагуу шаардлагатай үед.',
          '•  Гуравдагч талын үйлчилгээ үзүүлэгчтэй (жишээ нь, төлбөрийн систем, хүргэлтийн компани гэх мэт) мэдээллийг зөвхөн үйлчилгээний гүйцэтгэлийн хүрээнд хуваалцана.'
        ]
      }
    ]
  },
  {
    title: 'Хувийн мэдээллийг хамгаалах',
    content: [
      {
        section: '3.1',
        description:
          '. Бид таны мэдээллийг хамгаалахын тулд дараах арга хэмжээг авч хэрэгжүүлнэ:',
        details: [
          '•  Мэдээллийг шифрлэх.',
          '•  Зөвшөөрөлгүй нэвтрэлтийг хамгаалах аюулгүй байдлын систем ашиглах.',
          '•  Хувийн мэдээлэлд хандах эрхийг зөвхөн шаардлагатай ажилтнуудад хязгаарлах.'
        ]
      },
      {
        section: '3.2',
        description:
          '. Хэрэглэгчийн мэдээллийг хамгаалах талаар бид байнгын хяналт тавьдаг боловч цахим орчны аливаа аюулгүй байдлын зөрчил үүсэхээс 100% сэргийлэх баталгаа өгч чадахгүй.'
      }
    ]
  },
  {
    title: 'Мэдээллийг хадгалах хугацаа',
    content: [
      {
        section: '4.1',
        description:
          '. Бид хэрэглэгчийн хувийн мэдээллийг дараах хугацаанд хадгална:',
        details: [
          '•  Үйлчилгээний зорилгод шаардлагатай хугацаанд.',
          '•  Хуульд заасан хугацаанд.'
        ]
      },
      {
        section: '4.2',
        description:
          '. Хэрэв хэрэглэгчийн мэдээлэл хадгалах шаардлагагүй болсон тохиолдолд түүнийг устгана.'
      }
    ]
  },
  {
    title: 'Хэрэглэгчийн эрх',
    content: [
      {
        section: '5.1',
        description: '. Хэрэглэгч дараах эрхүүдийг эдэлнэ:',
        details: [
          '•  Өөрийн мэдээлэлд хандах, шалгах, засварлах.',
          '•  Мэдээлэл цуглуулах, ашиглахыг хориглох хүсэлт гаргах.',
          '•  Бидэнд хадгалж буй мэдээллийг устгахыг хүсэх.'
        ]
      },
      {
        section: '5.2',
        description:
          '. Эдгээр эрхээ хэрэгжүүлэхийн тулд хэрэглэгч contact@cellclinic.mn-аар бидэнтэй холбогдох боломжтой.'
      }
    ]
  },
  {
    title: 'Cookie болон гуравдагч талын үйлчилгээ',
    content: [
      {
        section: '6.1',
        description:
          '. Веб сайт нь хэрэглэгчийн туршлагыг сайжруулах зорилгоор cookies ашиглана.'
      },
      {
        section: '6.2',
        description:
          '. Гуравдагч талын аналитик үйлчилгээ (жишээ нь Google Analytics) ашиглах боломжтой. Энэ нь хэрэглэгчийн веб сайтад зочилсон байдал, хандалтын талаарх мэдээллийг цуглуулдаг.'
      }
    ]
  },
  {
    title: 'Нууцлалын бодлогын өөрчлөлт',
    content: [
      {
        section: '7.1',
        description:
          '. Бид энэхүү нууцлалын бодлогыг өөрчлөх эрхтэй бөгөөд шинэчилсэн хувилбарыг веб сайт дээр нийтэлснээр хүчин төгөлдөр болно.'
      },
      {
        section: '7.2',
        description:
          '. Хэрэглэгч шинэчилсэн бодлогыг зөвшөөрөхгүй тохиолдолд веб сайтыг ашиглахаа зогсоох эрхтэй.'
      }
    ]
  }
]

export default function Policy () {
  const { id } = useParams()
  const pageId = Number(id) || 0;
  const [clicked, setClick] = useState(pageId)
  const [isScrolled, setIsScrolled] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50)
    }

    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])
  const changeCategory = () => {
    if (clicked === 1) {
      setClick(0)
    } else {
      setClick(1)
    }
  }

  const renderContent = () => {
    if (clicked === 1) {
      return (
        <div>
          {termsAndConditions.map((section, index) => (
            <div key={index}>
              <Heading className='text-[14px] font-bold mt-[12px] mobile:text-[12px]'>
                {section.section}
              </Heading>
              {section.content.map((item, idx) => (
                <Text
                  key={idx}
                  className='text-[14px] mt-[12px] mobile:text-[12px]'
                >
                  {Array.isArray(item) ? item.title.join(' ') : item.title}
                  <ul className='text-[14px]  mt-[12px] mobile:text-[12px]'>
                    {item.items &&
                      item.items.map((detail, dIdx) => (
                        <li
                          className='text-[14px]  mt-[12px] mobile:text-[12px]'
                          key={dIdx}
                        >
                          {detail}
                        </li>
                      ))}
                  </ul>
                </Text>
              ))}
            </div>
          ))}
        </div>
      )
    } else {
      return (
        <div>
          {privacyPolicy.map((policy, index) => (
            <div key={index}>
              <p className='text-[14px] font-bold mt-[12px] mobile:text-[12px]'>
                {policy.title}
              </p>
              {policy.content.map((section, idx) => (
                <div key={idx}>
                  <p
                    className='text-[14px] mt-[12px] mobile:text-[12px]'
                    style={{
                      lineHeight: 2
                    }}
                  >
                    {section.section}
                    {section.description}
                  </p>
                  <ul style={{ marginLeft: 10, marginTop: 10 }}>
                    {section.details &&
                      section.details.map((detail, dIdx) => (
                        <li
                          className='text-[14px]  mt-[12px] mobile:text-[12px]'
                          // style={{ marginTop: 10, fontWeight: 300 }}
                          key={dIdx}
                        >
                          {detail}
                        </li>
                      ))}
                  </ul>
                </div>
              ))}
            </div>
          ))}
        </div>
      )
    }
  }

  return (
    <>
      <div
        style={{
          alignSelf: 'stretch',
          background: '#3784C7'
        }}
      >
        <div
          className={`fixed top-0 left-1/2 transform -translate-x-1/2 w-full  z-50 transition-all duration-300 ${
            isScrolled
              ? 'bg-blue shadow-md h-[7vh] top-1 max-w-[1440px] extraScreen:max-w-[1500px]'
              : 'bg-transparent h-[5vh]'
          }`}
        >
          <Header
            color={isScrolled ? 'black' : 'white'}
            gradientColor={isScrolled ? 'bg-white/90' : 'bg-none'}
          />
        </div>
        <div className='flex flex-row items-center justify-center h-full sm:flex-col md:flex-row  maxScreen:max-w-[1440px]  extraScreen:max-w-[1660px] maxScreen:mx-auto extraScreen:mx-auto mobile:flex-col'>
          <div className='w-[100%] h-[448px] flex flex-col justify-center items-center mobile:h-[200px]'>
            {/* <Text
              className='text-[#101828] '
              style={{
                marginTop: 20,
                fontSize: 16,
                fontWeight: 700,
                color: 'white',
                width: '50%',
                textAlign: 'center'
              }}
            >
              Current as of 1 Jan 2025
            </Text> */}
            <Heading
              size='heading4x1'
              as='h2'
              className='text-center text-[45px] font-bold w-[820px] text-white mobile:text-[24px] mobile:w-full'
            >
              Сellclinic.mn веб хуудасны
              {clicked === 0 ? ' Нууцлалын бодлого' : ' Үйлчилгээний нөхцөл'}
            </Heading>
          </div>
        </div>
      </div>
      <div className='p-10 mobile:p-0 maxScreen:max-w-[1440px]  extraScreen:max-w-[1660px] maxScreen:mx-auto extraScreen:mx-auto h-[100%]'>
        <div className='flex flex-row mobile:flex-col '>
          {/* category  */}
          <div className='flex flex-col w-[400px] p-[30px] mobile:flex-row mobile:w-full'>
            {['Нууцлалын бодлого', 'Үйлчилгээний нөхцөл'].map((item, index) => (
              <div key={index} onClick={() => changeCategory(index)}>
                <button
                  className='px-4 text-[14px] font-bold mb-5'
                  style={{
                    fontWeight: clicked === index ? 700 : 400,
                    border: '1px solid #215998',
                    borderTop: 'none',
                    borderRight: clicked === index ? 'none' : 'none',
                    borderBottom: 'none',
                    borderLeft:
                      clicked === index ? '1px solid #215998' : 'none',
                    color:
                      clicked === index
                        ? '#215998'
                        : 'var(--On-Surface-Medium, #626578)',
                    cursor: 'pointer'
                  }}
                >
                  {item}
                </button>
              </div>
            ))}
          </div>
          <div className='flex flex-col mt-5 mobile:px-[30px] mobile:mt-0 w-[800px] extraScreen:w-[1200px] mobile:w-full'>
            {/* <button onClick={changeCategory}>
              {clicked === 0 ? 'Нууцлалын бодлого' : 'Үйлчилгээний нөхцөл'}
            </button> */}
            {renderContent()}
          </div>
        </div>
      </div>
      <div className='px-20 maxScreen:max-w-[1440px]  extraScreen:max-w-[1660px] maxScreen:mx-auto extraScreen:mx-auto mobile:p-5 '>
        <ConnectUs bgImage='blue'></ConnectUs>
        <FooterSection></FooterSection>
      </div>
    </>
  )
}
